// extracted by mini-css-extract-plugin
export var fullHeightState = "_51-7";
export var headerCell = "_51-1";
export var loadingStateCell = "_51-4";
export var rowWrapper = "_51-3";
export var standaloneTable = "_51-8";
export var standaloneTableWithBodyFill = "_51-9";
export var stateCell = "_51-5";
export var table = "_51-0";
export var tableBodyFiller = "_51-6";
export var white = "_51-2";